import { ReactNode } from "react"
import { createPortal } from "react-dom"

export const Fullscreen = ({
  children,
  enabled,
}: {
  children: ReactNode
  enabled?: boolean
}) => {
  if (!enabled) return children
  return createPortal(
    <div className="pointer-events-auto fixed top-0 left-0 z-[9999] h-screen w-screen bg-white">
      {children}
    </div>,
    document.body,
  )
}
